import { FileText } from "lucide-react";

const Row = ({ label, value }) => {
  if (value === null || value === undefined || value === "" || (Array.isArray(value) && !value.length)) return null;
  return (
    <div className="flex justify-between gap-4 py-1.5 border-b border-slate-50">
      <span className="text-xs text-slate-500">{label}</span>
      <span className="text-xs font-medium text-navy text-right">{Array.isArray(value) ? value.join(", ") : String(value)}</span>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div className="bg-white rounded-2xl border border-slate-100 p-4">
    <h4 className="font-heading font-semibold text-navy text-sm mb-2">{title}</h4>
    {children}
  </div>
);

export default function ApplicationPreview({ me }) {
  const org = me.org || {};
  const contact = me.contact || {};
  const clinical = me.clinical_full || me.clinical || {};
  const coverage = me.coverage || {};
  const ins = clinical.liability_insurance || {};
  const docs = me.documents || {};
  return (
    <div className="space-y-3" data-testid="th-application-preview">
      <Section title="Organization">
        <Row label="Legal name" value={org.legal_name} /><Row label="Practice name" value={org.practice_name} />
        <Row label="Type" value={org.org_type} /><Row label="Address" value={org.address} />
        <Row label="Main phone" value={org.main_phone} /><Row label="Scheduling phone" value={org.scheduling_phone} />
        <Row label="General email" value={org.general_email} /><Row label="Website" value={org.website} />
        <Row label="Time zone" value={org.timezone} /><Row label="Office hours" value={org.office_hours} />
        <Row label="Languages" value={org.languages} />
      </Section>
      <Section title="Primary contact">
        <Row label="Name" value={contact.name} /><Row label="Title" value={contact.title} />
        <Row label="Email" value={contact.email} /><Row label="Mobile" value={contact.mobile} />
      </Section>
      <Section title="Clinical & licenses">
        <Row label="Provider type" value={(clinical.provider_type || "").replace(/_/g, " ")} />
        <Row label="Liability insurance" value={ins.active ? `Active — ${ins.carrier || ""}` : "Not on file"} />
        <Row label="Policy expires" value={ins.policy_expires} />
        {(clinical.roster || []).map((r, i) => (
          <Row key={i} label={r.name || `Provider ${i + 1}`}
            value={`${r.credential_type || ""} · ${r.license_state || ""} · Lic ${r.license_number || "—"} · exp ${r.expires_at || "—"}${r.npi ? ` · NPI ${r.npi}` : ""}`} />
        ))}
      </Section>
      <Section title="Coverage & availability">
        <Row label="States" value={(coverage.states || []).length ? coverage.states : "All states"} />
        <Row label="Accepting new clients" value={(me.availability || {}).accepting_new_clients ? "Yes" : "No"} />
      </Section>
      <Section title="Documents">
        {Object.keys(docs).length === 0 ? <p className="text-xs text-slate-400">No documents uploaded.</p> :
          Object.entries(docs).map(([k, v]) => (
            <div key={k} className="flex items-center gap-2 py-1.5 border-b border-slate-50 text-xs">
              <FileText className="w-3.5 h-3.5 text-cobalt" />
              <span className="font-medium text-navy">{k.replace(/_/g, " ")}</span>
              <span className="text-slate-400">{v.filename}</span>
            </div>
          ))}
      </Section>
    </div>
  );
}
